module.exports = __webpack_public_path__ + "img/CO.8864e3ab.svg";